<template>
  <PodcastPaywall :podcast="context">
    <template #active>
      <DoubleColumn>
        <template #header>
          <h1 class="text-3xl font-bold text-white">
            Neues Experiment starten
          </h1>
        </template>
        <template #left>
          <div v-if="resource" class="bg-white shadow sm:rounded-md">
            <div class="py-6 px-4 sm:p-6 lg:pb-8">
              <ExperimentForm :resource="resource" :errors="errors" />
            </div>
            <div class="px-6 pb-6 divide-y divide-gray-200">
              <div class="flex justify-end">
                <CancelButton @click="onCancel" class="mr-2">
                  Abbrechen
                </CancelButton>
                <SubmitButton @click="onSubmit" :load="creating">
                  Experiment erstellen
                </SubmitButton>
              </div>
            </div>
          </div>
        </template>
        <template #right>
          <ObjectiveWidget :podcast="context" />
        </template>
      </DoubleColumn>
    </template>
    <template #inactive>
      <SingleColumn>
        <template #header>
          <section class="sm:flex sm:items-center sm:justify-between">
            <div class="sm:flex sm:space-x-5">
              <h1 class="text-3xl font-bold text-white">
                Experimente sind Teil vom Studio Pro
              </h1>
            </div>
          </section>
        </template>
        <template #content>
          <ConversionTrigger :podcast="context" />
        </template>
      </SingleColumn>
    </template>
  </PodcastPaywall>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import { useCreateResource } from '@/client/actions';

const store = useStore();
const route = useRoute();
const router = useRouter();

const context = computed(() => store.getters['context/context']);
const parent = computed(() => context.value.id ?? null);
const target = computed(() => '/api/podcasts/' + parent.value + '/experiments');
const initial = computed(() => ({practice_id: route.query.practice_id ?? null}));

const action = useCreateResource(target, initial.value);

const { resource, errors, message, create, creating } = action;

const refresh = () => store.dispatch('context/refresh', parent.value);
const redirect = () => router.push({name: 'experiments.list'});
const callback = () => refresh().then(() => redirect());

const onSubmit = () => create(callback);
const onCancel = () => router.go(-1);
</script>
